import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import { 
    FormGroup,
	Label,
 } from 'Actions';

 // app config
import AppConfig from 'Constants/AppConfig';
 // rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

class ViewItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {

	}

    constructor(props) {
      
        super(props);
        this.nodeRef = React.createRef();
        this.state = {  
            seldate:'', 
            student:'', 
            heightProportion: 1600,
            widthProportion: 500
        };
    }


render() {

    const { particularcaptoreport, loading} = this.props; 
    const allfile=particularcaptoreport[0].tsr_filename;
    if(allfile==''){
        var exfiles=[];
        var filecnt=0;
    }else{
        var exfiles=allfile.split(',');
        var filecnt=exfiles.length;
    }

    const styles = {
        subheading: {
            fontWeight:"bold",
            width:"60%"
        }

    }    
      return(
            <div>
                <div className="col-md-12">
                    <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard heading="PUTTING EVALUATION DETAILS">
                                    <div className="float-right">
                                        <button type="button" className="mr-10 mb-10 btn btn-outline-warning " onClick={this.props.onClick}>Back</button> 
                                    </div> 
                                    <div className="table-responsive">
                                        <Table hover bordered striped>
                                            
                                            <tbody>                              
                                            
                                                <tr>
                                                    <td style={{width:"40%"}}>STUDENT</td>
                                                    <td style={styles.subheading}> {particularcaptoreport[0].student} </td>
                                                </tr>
                                                <tr>
                                                    <td>DATE</td>
                                                    <td style={styles.subheading}> {particularcaptoreport[0].cdate} </td>
                                                </tr>
                                                {particularcaptoreport.map((lumbval, idx) => (                                                   
                                                    <tr>
                                                        <td>{lumbval.gte_name}</td>
                                                        <td style={styles.subheading}> {lumbval.tsr_observation} </td>
                                                    </tr>                                                
                                                ))}
                                                <tr>
                                                    <td>Report Name</td>
                                                    <td style={styles.subheading}> {particularcaptoreport[0].tsr_reportname} </td>
                                                </tr>

                                                                    
                                            </tbody>
                                        </Table>
                                    </div>   
                                </RctCollapsibleCard>
                            </div> 
                            <div className="col-sm-12 col-md-6" ref={this.nodeRef}>
                                <CarouselProvider                            
                                    naturalSlideWidth={this.state.widthProportion}
                                    naturalSlideHeight={this.state.heightProportion}
                                    totalSlides={filecnt}
                                >
                                <div className="sdfsdf">
                                    <div className="text-center" style={{marginTop:"-30px"}}>
                                        {exfiles.map((uptval,idx) => ( 
                                            <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                        ))}
                                    </div>                        
                                </div>
                                <Slider>
                                {exfiles.map((uptval,idx) => (                                  
                                        <Slide index={idx}> 
                                        <RctCollapsibleCard>
                                            <iframe src={AppConfig.apiurl+'/theme/img/capto/'+uptval} width="100%" height={600} ></iframe>
                                        </RctCollapsibleCard>
                                        </Slide>
                                ))}        
                                </Slider>
                                </CarouselProvider>    
                            </div>


                    </div>
                </div>
            </div>
              
    )
   
}
 
}

const mapStateToProps = ({ captoreport}) => {
    const { particularcaptoreport, loading } = captoreport;
	return { particularcaptoreport, loading };
   
}


export default connect(mapStateToProps, {
    
  
})(ViewItems);
